import "./Statistics.css";

export const Statistics = ({ title, data }) => {
  return (
    <section className="statistics">
      <h2 className="title">{title}</h2>
      <ul className="stat-list">
        <li style={{ backgroundColor: "#50BEF1" }} className="item">
          <span className="label">{data[0].label}</span>
          <span className="percentage">4%</span>
        </li>
        <li style={{ backgroundColor: "#A13FEF" }} className="item">
          <span className="label">{data[1].label}</span>
          <span className="percentage">14%</span>
        </li>
        <li style={{ backgroundColor: "#DE4F68" }} className="item">
          <span className="label">{data[2].label}</span>
          <span className="percentage">41%</span>
        </li>
        <li style={{ backgroundColor: "#21B3BC" }} className="item">
          <span className="label">{data[3].label}</span>
          <span className="percentage">12%</span>
        </li>
      </ul>
    </section>
  );
};
